import AuthLayout from "components/Organisms/login/layout/AuthLayout";
import ForgetPasswordPage from "pages/auth/forgetPassword";
import LoginPage from "pages/auth/login";
import ResetPasswordPage from "pages/auth/resetPassword";
import ResetPasswordSuccessPage from "pages/auth/resetPasswordSuccess";
import VerifyOTPPage from "pages/auth/verifyOTP";
import BetweenZonesFeesPage from "pages/between-zones-fees/BetweenZonesFees";
import CitiesPage from "pages/cities/Cities";
import GiftCardsPage from "pages/gift-cards/GiftCards";
import PromoCodesPage from "pages/promo-codes/PromoCodes";
import MeritOrdersPage from "pages/merit/MeritOrders";
import MeritApiLogsPage from "pages/merit/MeritApiLogs";
import BannersPage from "pages/look-ups/Banners";
import SystemConfigurationPage from "pages/look-ups/SystemConfiguration";
import TagPage from "pages/look-ups/Tag";
import OccasionsTypes from "pages/occasions/occasionsTypes";
import ServicesPage from "pages/look-ups/Services";
import EventPlanningPage from "pages/event-planning/EventPlanning";
import ThemesPage from "pages/look-ups/Themes";
import RolesPage from "pages/roles/Roles";
import AdminUsersPage from "pages/users/admin-users/AdminUsers";
import ChangePasswordPage from "pages/users/admin-users/ChangePassword";
import ZonesPage from "pages/zones/Zones";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { getSystemConfigRequest } from "services/modules/systemConfig";
import OrderDeclinationPage from "../pages/look-ups/OrderDeclinationReasons";
import Layout from "./layout";

import MessengerPage from "pages/chat/messenger";
import CategoriesPage from "pages/look-ups/categories";
import BrandsPage from "pages/look-ups/brands";
import SubcategoriesPage from "pages/look-ups/subcategories";
import OrdersPage from "pages/orders/orders.page";
import CartLogsPage from "pages/cart-logs/cart-logs.page";
import ProductsPage from "pages/products/Products";
import EditProductPage from "pages/products/editProduct";
import CustomersPage from "pages/users/customers/customers";
import ChangeUserPasswordPage from "pages/users/drivers/employee/changeUserPasswordPage";
import EmployeePage from "pages/users/drivers/employee/employee";
import FreeLancerPage from "pages/users/drivers/freelancer/freelancer";
import Colors from "pages/wrappers/colors";
import RibbonColor from "pages/wrappers/ribbonColor";
import Shapes from "pages/wrappers/shapes";
import Wraps from "pages/wrappers/wraps";
import WrapsExtras from "pages/wrappers/wrapsExtras";
import WrapsVariants from "pages/wrappers/wrapsVariant";
import { useNavigate, Navigate } from "react-router";
import { getUserProfileRequest } from "services/modules/authenticate";
import CustomerComplaintsPage from "../pages/complaints/customerComplaints";
import DriverComplaintsPage from "../pages/complaints/driverComplaints";
import DeliverTimesPage from "../pages/look-ups/DeliveryTimes";
import DeliverySchedulePage from "../pages/look-ups/DeliverySchedule";
import ProductsOptionTypesPage from "../pages/look-ups/ProductsOptionTypes";
import ProductsOptionValuesPage from "../pages/look-ups/ProductsOptionValues";
import CustomerComplaintsReasonsPage from "../pages/look-ups/complaints-reasons/CustomerComplaintsReasons";
import DriverComplaintsReasonsPage from "../pages/look-ups/complaints-reasons/DriverComplaintsReasons";
import UsersOccasionsPage from "../pages/occasions/usersOccasions";
import EditVendorPage from "../pages/vendor/editVendor";
import Vendor from "../pages/vendor/vendor";
import VendorRegistration from "../pages/vendor/vendorRegistration";
import SuggestedWraps from "../pages/wrappers/suggestedWraps";
import PackagingSettingsPage from "../pages/wrappers/packagingSettings";
import EventsSettingsPage from "pages/events/eventsSettings";
import EventTypesPage from "pages/events/eventTypes";
import PackagesPage from "pages/events/packages";
import BookingsPage from "pages/events/bookings";
import BookingDetailsPage from "pages/events/bookingDetails";
// import {GetUserProfileSuccess} from "../services/modules/authenticate";
import { onValue, ref } from "firebase/database";
import AdminProfilePage from "pages/admin-profile/adminProfile";
import OrderDetailsPage from "pages/orders/ordersDetails.page";
import CreateReturnRequestPage from "pages/orders/return-order/createReturnRequestPage";
import ReturnRequestDetailsPage from "pages/orders/return-order/returnRequestDetailsPage";
import ReturnRequestsPage from "pages/orders/return-order/returnRequestPage";
import PushNotificationsPage from "pages/push-notifications/PushNotifications";
import VendorChangePasswordPage from "pages/vendor/ChangePasswprd";
import FinancialPage from "pages/financial/Financial";
import { SetFCMToken } from "services/modules/notifications/notifications/Action";
import { StoreUser } from "services/modules/utils/constant";
import { db, requestForFCMToken } from "services/utils/firebase";
import LandingPage from "pages/landing/LandingPage";
import Dashboard from "pages/dashboard/Dashboard";
import BestSellingProducts from "pages/dashboard/BestSellingProducts";
import SalesReport from "pages/dashboard/SalesReport";
import SoldQuantitiesReport from "pages/dashboard/SoldQuantitiesReport";
import VatReport from "pages/dashboard/VatReport";
import EmployeesPage from "pages/employees/Employees";

const ProtectedRoute = ({ children, isAllowed = false }) => {
  const navigate = useNavigate();
  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const isSuperAdmin = currentUser?.privilege === "super_admin";

  if (!localStorage.getItem("token")) {
    navigate("/login");
    return null;
  }

  if (isSuperAdmin || isAllowed) {
    return children;
  }
  return null;
};

const AppRoute = () => {
  //permissions
  const currentUser = useSelector(
    (state) => state.authenticate.currentUserProfile,
  );
  const permissions = useSelector(
    (state) => state.authenticate.currentUserProfile.permissions,
  );
  const isSuperAdmin = currentUser?.privilege == "super_admin";
  const userType = localStorage.getItem("user_type");
  const accountType =
    localStorage.getItem("account_type") || currentUser?.account_type;
  const [isAuth, setIsAuth] = useState(false);
  const dispatch = useDispatch();
  const [notificationUnseenCount, setNotificationUnseenCount] = useState(0);

  let [searchParams, setSearchParam] = useSearchParams();
  const id = searchParams.get("id");
  const isStore =
    localStorage?.getItem("user_type") == "Store" ||
    accountType?.toLowerCase() == "store";
  useEffect(() => {
    dispatch(
      getSystemConfigRequest({
        params: {
          page_size: 10,
          page_number: 1,
          keyword: "",
          sort_by: "id",
        },
      }),
    );
  }, []);

  useEffect(() => {
    isAuth && dispatch(getUserProfileRequest({}));
  }, [isAuth]);

  useEffect(() => {
    // on page load
    const token = localStorage.getItem("token");
    setIsAuth(Boolean(token));

    // when the storage changes
    const handleStorageListener = () => {
      const token = localStorage.getItem("token");
      setIsAuth(Boolean(token));
    };
    window.addEventListener("storage", handleStorageListener);

    //clean up
    return () => {
      window.removeEventListener("storage", handleStorageListener);
    };
  }, []);

  const FCMToken = useSelector((state) => state.notifications.FCMToken);
  const [newFCMToken, setNewFCMToken] = useState(null);

  useEffect(() => {
    requestForFCMToken(setNewFCMToken);
    if (newFCMToken && newFCMToken != FCMToken) {
      // send a request to set the FCMToken
      dispatch(SetFCMToken({ token: newFCMToken }));
    }
  }, [newFCMToken]);

  // useEffect(() => {
  //   onMessageListener()
  //     .then((payload) => {
  //       dispatch(getUnreadCountRequest({}));
  //     })
  //     .catch((err) => console.error("Error receiving notification:", err));
  // }, []);

  useEffect(() => {
    const userNode = localStorage.getItem("firebase_uid");
    const starCountRef = ref(db, `users/${userNode}/notification_count`);
    onValue(starCountRef, (snapshot) => {
      // dispatch(getUnreadCountRequest({}));
      setNotificationUnseenCount(snapshot?.val());
    });
  }, []);

  if (isAuth && accountType?.toLowerCase() === "employee") {
    return (
      <Routes>
        <Route path="/" element={<LandingPage isAuth={isAuth} />} />
        <Route path="/login" element={<Navigate to="/orders" replace />} />
        <Route
          element={<Layout notificationUnseenCount={notificationUnseenCount} />}
        >
          <Route path="orders" element={<OrdersPage />} />
          <Route path="order-details" element={<OrderDetailsPage />} />
          <Route
            path="create-return-request"
            element={<CreateReturnRequestPage />}
          />
          <Route
            path="return-request-details"
            element={<ReturnRequestDetailsPage />}
          />
          <Route path="return-request" element={<ReturnRequestsPage />} />
          <Route path="messenger" element={<MessengerPage />} />
          <Route path="*" element={<Navigate to="/orders" replace />} />
        </Route>
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage isAuth={isAuth} />} />
      {/* Redirect authenticated users from login to dashboard */}
      {isAuth && (
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
      )}
      {isAuth ? (
        <Route
          element={<Layout notificationUnseenCount={notificationUnseenCount} />}
        >
          <Route path={"dashboard"} element={<Dashboard />} />

          <Route
            path={"dashboard/best-selling-products"}
            element={
              <ProtectedRoute isAllowed={userType !== "Store"}>
                <BestSellingProducts />
              </ProtectedRoute>
            }
          />
          <Route
            path={"dashboard/sales-report"}
            element={
              <ProtectedRoute isAllowed={userType !== "Store"}>
                <SalesReport />
              </ProtectedRoute>
            }
          />
          <Route
            path={"dashboard/sold-quantities-report"}
            element={
              <ProtectedRoute isAllowed={userType !== "Store"}>
                <SoldQuantitiesReport />
              </ProtectedRoute>
            }
          />
          <Route
            path={"dashboard/vat-report"}
            element={
              <ProtectedRoute isAllowed={userType !== "Store"}>
                <VatReport />
              </ProtectedRoute>
            }
          />
          <Route
            path={"admin-profile"}
            element={
              <ProtectedRoute isAllowed={true}>
                <AdminProfilePage />
              </ProtectedRoute>
            }
          />

          <Route
            path={"vendors"}
            element={
              <ProtectedRoute
                isAllowed={
                  permissions?.stores?.can_read ||
                  (userType == "Store" && currentUser?.id == id)
                }
              >
                <Vendor />
              </ProtectedRoute>
            }
          />

          <Route
            path="vendors/:id"
            element={
              <ProtectedRoute
                isAllowed={permissions?.stores?.can_read || userType == "Store"}
              >
                <EditVendorPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="employees"
            element={
              <ProtectedRoute isAllowed={userType === "Store"}>
                <EmployeesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="tags"
            element={
              <ProtectedRoute isAllowed={permissions?.tags?.can_read}>
                <TagPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="featured-ads"
            element={
              <ProtectedRoute
                isAllowed={permissions?.featured_banners?.can_read}
              >
                <BannersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/delivery-times"
            element={
              <ProtectedRoute isAllowed={permissions?.delivery_times?.can_read}>
                <DeliverTimesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/delivery-schedule"
            element={
              <ProtectedRoute isAllowed={permissions?.delivery_times?.can_read}>
                <DeliverySchedulePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="wraps"
            element={
              <ProtectedRoute isAllowed={permissions?.wraps?.can_read}>
                <Wraps />
              </ProtectedRoute>
            }
          />

          <Route
            path="shapes"
            element={
              <ProtectedRoute isAllowed={permissions?.shapes?.can_read}>
                <Shapes />
              </ProtectedRoute>
            }
          />

          <Route
            path="colors"
            element={
              <ProtectedRoute isAllowed={permissions?.colors?.can_read}>
                <Colors />
              </ProtectedRoute>
            }
          />

          <Route
            path="wrap-variants"
            element={
              <ProtectedRoute isAllowed={permissions?.wrap_variants?.can_read}>
                <WrapsVariants />
              </ProtectedRoute>
            }
          />

          <Route
            path="ribbon-colors"
            element={
              <ProtectedRoute isAllowed={permissions?.ribbon_colors?.can_read}>
                <RibbonColor />
              </ProtectedRoute>
            }
          />

          <Route
            path="wraps-extras"
            element={
              <ProtectedRoute isAllowed={permissions?.wrap_extras?.can_read}>
                <WrapsExtras />
              </ProtectedRoute>
            }
          />

          <Route
            path={"/suggested-wrappers"}
            element={
              <ProtectedRoute
                isAllowed={permissions?.suggested_wrappers?.can_read}
              >
                <SuggestedWraps />{" "}
              </ProtectedRoute>
            }
          />

          <Route
            path="packaging-settings"
            element={
              <ProtectedRoute
                isAllowed={permissions?.system_configurations?.can_read}
              >
                <PackagingSettingsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="events/settings"
            element={
              <ProtectedRoute
                isAllowed={
                  isSuperAdmin || permissions?.system_configurations?.can_read
                }
              >
                <EventsSettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/event-types"
            element={
              <ProtectedRoute
                isAllowed={isSuperAdmin || permissions?.event_types?.can_read}
              >
                <EventTypesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/services"
            element={
              <ProtectedRoute
                isAllowed={isSuperAdmin || permissions?.products?.can_read}
              >
                <ProductsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/services/:id"
            element={
              <ProtectedRoute
                isAllowed={isSuperAdmin || permissions?.products?.can_update}
              >
                <EditProductPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/packages"
            element={
              <ProtectedRoute
                isAllowed={isSuperAdmin || permissions?.packages?.can_read}
              >
                <PackagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/bookings"
            element={
              <ProtectedRoute
                isAllowed={isSuperAdmin || permissions?.bookings?.can_read}
              >
                <BookingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/bookings/:bookingId"
            element={
              <ProtectedRoute
                isAllowed={isSuperAdmin || permissions?.bookings?.can_read}
              >
                <BookingDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="events/orders"
            element={
              <ProtectedRoute isAllowed={permissions?.orders?.can_read}>
                <OrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="orders"
            element={
              <ProtectedRoute isAllowed={permissions?.orders?.can_read}>
                <OrdersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="cart-logs"
            element={
              <ProtectedRoute isAllowed={permissions?.orders?.can_read}>
                <CartLogsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="order-details"
            element={
              <ProtectedRoute isAllowed={permissions?.orders?.can_read}>
                <OrderDetailsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="create-return-request"
            element={
              <ProtectedRoute isAllowed={userType != StoreUser}>
                <CreateReturnRequestPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="return-request-details"
            element={
              <ProtectedRoute isAllowed={userType != StoreUser}>
                <ReturnRequestDetailsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path={"return-request"}
            element={
              <ProtectedRoute>
                <ReturnRequestsPage
                  isAllowed={permissions?.return_requests?.can_read}
                />
              </ProtectedRoute>
            }
          />

          <Route
            path="/categories"
            element={
              <ProtectedRoute isAllowed={permissions?.categories?.can_read}>
                <CategoriesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/categories/:categoryId/subcategories"
            element={
              <ProtectedRoute isAllowed={permissions?.categories?.can_read}>
                <SubcategoriesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/brands"
            element={
              <ProtectedRoute isAllowed={permissions?.brands?.can_read}>
                <BrandsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/occasions"
            element={
              <ProtectedRoute isAllowed={permissions?.occasions?.can_read}>
                <UsersOccasionsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="occasions-types"
            element={
              <ProtectedRoute isAllowed={permissions?.occasion_types?.can_read}>
                <OccasionsTypes />
              </ProtectedRoute>
            }
          />

          <Route
            path={"products-option-types"}
            element={
              <ProtectedRoute isAllowed={permissions?.option_types?.can_read}>
                <ProductsOptionTypesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="customers"
            element={
              <ProtectedRoute isAllowed={permissions?.customers?.can_read}>
                <CustomersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="messenger"
            element={
              <ProtectedRoute isAllowed={permissions?.chat_rooms?.can_read}>
                <MessengerPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="customer-complaints"
            element={
              <ProtectedRoute isAllowed={{}}>
                <CustomerComplaintsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="driver-complaints"
            element={
              <ProtectedRoute isAllowed={{}}>
                <DriverComplaintsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path={"products-option-values"}
            element={
              <ProtectedRoute isAllowed={permissions?.option_values?.can_read}>
                <ProductsOptionValuesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="system-configurations"
            element={
              <ProtectedRoute
                isAllowed={permissions?.system_configurations?.can_read}
              >
                <SystemConfigurationPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="lookups/services"
            element={
              <ProtectedRoute
              // isAllowed={isSuperAdmin || permissions?.services?.can_read}
              >
                <ServicesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="event-planning"
            element={
              <ProtectedRoute>
                <EventPlanningPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="lookups/themes"
            element={
              <ProtectedRoute
              // isAllowed={isSuperAdmin || permissions?.themes?.can_read}
              >
                <ThemesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="admin-users"
            element={
              <ProtectedRoute isAllowed={permissions?.admin_users?.can_read}>
                <AdminUsersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="admin-users/change-password/:id"
            element={
              <ProtectedRoute isAllowed={permissions?.admin_users?.can_update}>
                <ChangePasswordPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users/change-password/:id"
            element={
              <ProtectedRoute>
                <ChangeUserPasswordPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/vendors/change-password/:id"
            element={
              <ProtectedRoute>
                <VendorChangePasswordPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="customers"
            element={
              <ProtectedRoute isAllowed={permissions?.customers?.can_read}>
                <CustomersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="employee-drivers"
            element={
              <ProtectedRoute isAllowed={permissions?.drivers?.can_read}>
                <EmployeePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="freelancer-drivers"
            element={
              <ProtectedRoute isAllowed={permissions?.drivers?.can_read}>
                <FreeLancerPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="admin-users/roles"
            element={
              <ProtectedRoute>
                <RolesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="products"
            element={
              <ProtectedRoute isAllowed={permissions?.products?.can_read}>
                <ProductsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="products/:id"
            element={
              <ProtectedRoute isAllowed={permissions?.products?.can_update}>
                <EditProductPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="gift-cards"
            element={
              <ProtectedRoute
                isAllowed={permissions?.cart_gift_cards?.can_read}
              >
                <GiftCardsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="cities"
            element={
              <ProtectedRoute isAllowed={permissions?.google_cities?.can_read}>
                <CitiesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="zones"
            element={
              <ProtectedRoute isAllowed={permissions?.zones?.can_read}>
                <ZonesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="between-zones-fees"
            element={
              <ProtectedRoute
                isAllowed={permissions?.between_zones_fees?.can_read}
              >
                <BetweenZonesFeesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="customer-complaint-reasons"
            element={
              <ProtectedRoute
                isAllowed={permissions?.order_complaints?.can_read}
              >
                <CustomerComplaintsReasonsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="driver-complaint-reasons"
            element={
              <ProtectedRoute
                isAllowed={permissions?.route_complaints?.can_read}
              >
                <DriverComplaintsReasonsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="order-declination-reasons"
            element={
              <ProtectedRoute
                isAllowed={permissions?.order_declination_reasons?.can_read}
              >
                <OrderDeclinationPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="push-notifications"
            element={<PushNotificationsPage />}
          />
          <Route
            path="financial"
            element={
              <FinancialPage />
              // <ProtectedRoute isAllowed={isStore}>
              // </ProtectedRoute>
            }
          />
          <Route
            path="promo-codes"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <PromoCodesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="merit/orders"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <MeritOrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="merit/api-logs"
            element={
              <ProtectedRoute isAllowed={isSuperAdmin}>
                <MeritApiLogsPage />
              </ProtectedRoute>
            }
          />
        </Route>
      ) : (
        <React.Fragment>
          <Route path="/vendor-registration" element={<VendorRegistration />} />
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="forget-password" element={<ForgetPasswordPage />} />
            <Route path="verify-otp" element={<VerifyOTPPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route
              path="reset-password-success"
              element={<ResetPasswordSuccessPage />}
            />
          </Route>
        </React.Fragment>
      )}
    </Routes>
  );
};

export default AppRoute;
